import { call, put, takeEvery, select } from "redux-saga/effects";
import { setErrorServiceProviderProfile, setServiceProviderLoader, setServiceProviderProfile, setServiceProviderData, setServiceProviderWidgetLoader, setServiceProvidersList, setServiceProvidersListLoader, setResultServiceProvider } from "./actions";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";
import { ADD_SERVICE_PROVIDER, DELETE_SERVICE_PROVIDER, GET_SERVICE_PROVIDER, GET_SERVICE_PROVIDERS_LIST, GET_SERVICE_PROVIDER_WIDGET, UPDATE_SERVICE_PROVIDER } from "./actionTypes";
import { deleteServiceProviderApi, getServiceProviderProfileApi, getServiceProviderWidgets, getServiceProvidersApi, patchServiceProviderProfile, postServiceProviderApi } from "../../helpers/jwt_helper";

function* onGetServiceProvidersList({ payload: data }) {
  try {
    yield put(setServiceProvidersListLoader());

    let response = yield call(getServiceProvidersApi, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          description: i.description === "string" ? "" : i.description,
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setServiceProvidersList(response));
    yield put(setServiceProvidersListLoader());
  } catch (error) {
    yield put(setServiceProvidersListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddServiceProvider({ payload: { contractor, data } }) {
  try {
    yield put(setServiceProviderLoader());
    yield call(postServiceProviderApi, contractor);
    // yield call(onGetContractorList, { payload: data });
    yield put(setServiceProviderLoader());
    showSuccessMessage("Service provider has been added");
  } catch (error) {
    yield put(setServiceProviderLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteServiceProvider({ payload: { id, data } }) {
  try {
    yield put(setServiceProviderLoader());
    yield call(deleteServiceProviderApi, id);
    yield call(onGetServiceProvidersList, { payload: data });
    yield put(setServiceProviderLoader());
    showSuccessMessage("Service provider has been deleted");
  } catch (error) {
    yield put(setServiceProviderLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetServiceProviderProfile({ payload: id }) {
  try {
    yield put(setServiceProviderLoader());
    yield put(setErrorServiceProviderProfile(false));
    let response = yield call(getServiceProviderProfileApi, id);
    yield put(setServiceProviderProfile(response));
    yield put(setServiceProviderLoader());
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorServiceProviderProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(setServiceProviderLoader());
  }
}

function* onUpdateServiceProviderProfile({ payload: { id, contractor, data } }) {
  try {
    yield put(setServiceProvidersListLoader());
    yield call(patchServiceProviderProfile, id, contractor);
    // yield call(onGetContractorList, { payload: data });
    yield put(setServiceProvidersListLoader());
    showSuccessMessage("Service provider has been updated");
  } catch (error) {
    yield put(setServiceProvidersListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetServiceProviderWidget({ payload: data }) {
  try {
    yield put(setServiceProviderWidgetLoader());
    let widgetData = [
      ...(yield select(state => state.ServiceProviders.serviceProviderWidgets)),
    ];

    let response = yield call(getServiceProviderWidgets, {
      ...data,
    });

    let wData = {
      payment: response?.payment || 0,
      spend: response?.spend || 0,
      cashback: response?.cashback || 0,
    }

    let items = response?.items.length > 0 ? [ ...response.items] : [];

    Object.keys(wData).forEach((key, idx) => {
      widgetData[idx].value = response[key] || 0;
    });

    yield put(setServiceProviderData(widgetData));
    yield put(setResultServiceProvider({ results: items }));
    yield put(setServiceProviderWidgetLoader());
  } catch (error) {
    yield put(setServiceProviderWidgetLoader());
    yield put(setResultServiceProvider({ results: [] }));
  }
}

function* serviceProvidersSaga() {
  yield takeEvery(GET_SERVICE_PROVIDERS_LIST, onGetServiceProvidersList);
  yield takeEvery(DELETE_SERVICE_PROVIDER, onDeleteServiceProvider);
  yield takeEvery(ADD_SERVICE_PROVIDER, onAddServiceProvider);
  yield takeEvery(GET_SERVICE_PROVIDER, onGetServiceProviderProfile);
  yield takeEvery(UPDATE_SERVICE_PROVIDER, onUpdateServiceProviderProfile);
  yield takeEvery(GET_SERVICE_PROVIDER_WIDGET, onGetServiceProviderWidget);
}

export default serviceProvidersSaga;
